module.exports = __webpack_public_path__ + "img/hourglass.521382ad.png";